import { useState } from 'react';

import Cookies from 'js-cookie';

import UserInterfaceState from '../../stimulus/models/user-interface-state';

export type UserCookieState = {
  userInterfaceState: UserInterfaceState;
  cookieKey: string;
};

type Props = {
  messageId: string;
  userCookieState?: UserCookieState;
};

export function useMessageVisibility({ messageId, userCookieState }: Props) {
  const hiddenMessages = Cookies.get('hiddenMessages')?.split(',') || [];
  let isVisibleByDefault = !hiddenMessages.includes(messageId);

  const { userInterfaceState, cookieKey } = userCookieState || {};

  if (userInterfaceState && cookieKey) {
    isVisibleByDefault = !userInterfaceState.getStateFor(cookieKey);
  }

  const [isVisible, setIsVisible] = useState(isVisibleByDefault);

  if (userInterfaceState && cookieKey) {
    const hideMessage = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      userInterfaceState.setExpiresFor(cookieKey, 'dismissed');
      userInterfaceState.setStateFor(cookieKey, true);
      setIsVisible(false);
    };

    return { isVisible, hideMessage };
  }

  const hideMessage = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const updatedHiddenMessages = [...hiddenMessages, messageId];
    Cookies.set('hiddenMessages', updatedHiddenMessages.join(','));
    setIsVisible(false);
  };

  return { isVisible, hideMessage };
}
